import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class StandistByStandistModel extends ApiModel {
  static get path() {
    return '/backend/standist_by_standists/{?id}';
  }

  @computed
  public get user() {
    // retourne l'iri de l'utilisateur'
    return this.get('user');
  }
}
